import { render, staticRenderFns } from "./EditarQuestionarioForm.vue?vue&type=template&id=18822b3a&scoped=true"
import script from "./EditarQuestionarioForm.vue?vue&type=script&lang=js"
export * from "./EditarQuestionarioForm.vue?vue&type=script&lang=js"
import style0 from "./EditarQuestionarioForm.vue?vue&type=style&index=0&id=18822b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18822b3a",
  null
  
)

export default component.exports